var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-header"},[_c('b-row',[_c('b-col',[_c('icon-dashboard',{attrs:{"width":26,"height":26,"color":"#FFD102"}}),_c('span',{staticClass:"Dashboard"},[_vm._v("Dashboard")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }